module.exports = __webpack_public_path__ + "img/60.eac57682.jpeg";